<div class="questionContainer">
  <h2>{{model.name}}</h2>
  <form #questionForm="ngForm" novalidate>
    <p *ngIf="model.intro" [innerHTML]="model.intro"></p>
    <div *ngIf="introVideo && introVideo.encodingStatus === 'Succeeded' && introVideo.encodingOutput">
      <app-video-player [videoId]="model.applicantElementId"
                        [manifestUri]="introVideo.encodingOutput.playbackUrl"
                        [thumbnailUri]="introVideo.encodingOutput.thumbnailUrl"
                        [width]="640" [height]="480">
      </app-video-player>
    </div>
    <ng-template appQuestionHost></ng-template>
  </form>
</div>
